var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveSwitchRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 67,
    viewBox: "0 0 51 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1122 13.1222L0.883401 12.4425C0.578083 12.9945 0.678284 13.6823 1.12839 14.1242C1.5785 14.5662 2.26805 14.6537 2.81433 14.3383L2.1122 13.1222ZM9.43302 2.78839C9.80841 2.10975 9.56257 1.25528 8.88392 0.879898C8.20528 0.504511 7.35081 0.750351 6.97543 1.429L9.43302 2.78839ZM36.5717 63.8027C35.9673 64.2886 35.8712 65.1726 36.3572 65.777C36.8432 66.3814 37.7271 66.4774 38.3315 65.9914L36.5717 63.8027ZM2.81433 14.3383C16.9538 6.17489 35.1583 11.1683 43.4603 25.5477L45.8925 24.1435C36.8335 8.45278 16.9247 2.94872 1.41007 11.9061L2.81433 14.3383ZM3.341 13.8019L9.43302 2.78839L6.97543 1.429L0.883401 12.4425L3.341 13.8019ZM43.4603 25.5477C50.9833 38.5779 47.765 54.8028 36.5717 63.8027L38.3315 65.9914C50.6105 56.1187 54.1042 38.3665 45.8925 24.1435L43.4603 25.5477Z",
    fill: "#525D71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSwitchRight);
export default __webpack_public_path__ + "static/media/active-switch-right.ca39adb37e8fd7f7b8bca42522814ed6.svg";
export { ForwardRef as ReactComponent };